import React, { useState, useEffect } from "react"
import Flatpickr from "react-flatpickr"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import moment from "moment"
import {
  Container,
  Row,
  Card,
  CardBody,
  Col,
  Table,
  Button,
  Modal,
  CardTitle,
  FormGroup,
  Input,
  Label,
  CardSubtitle,
} from "reactstrap"
import { desOptions } from "./const"
import * as backend from "../../helpers/backend_helper"
import Toaster from "../../components/Common/Toaster"
import MwSelect from "../../components/Common/MwSelect"
import ReactApexChart from "react-apexcharts"
import _ from "lodash"

const Analysis = (props: any) => {
  const [userList, setuserList] = useState([])
  const [sortBy, setSortBy] = useState("person")
  const [range, setRange] = useState<any[]>([])
  const [user, setUserId] = useState("")
  const [finalReport, setFinalReport] = useState({})
  // const scopeList = Object.keys(desOptions)

  async function getUsers() {
    try {
      const orgId = props.selectedFactory["orgId"]
      const response = await backend.getUserOrg(orgId)
      setuserList(response)
    } catch (e) { }
  }

  async function filter() {
    const startDate = range[0]
    const endDate = range[1]
    if (!startDate || !endDate) {
      Toaster.error("Please select a date range")
      return
    }
    if (!user) {
      Toaster.error(sortBy === "person" ? "Please select a person" : "Please select a scope")
      return
    }
    try {
      const { orgId, _id: facId } = props.selectedFactory

      const response = await backend.getDailyWorkReportAnalysis(
        orgId,
        facId,
        startDate,
        endDate
      )
      // console.log("responseresponse", response)

      // setReportList(response)
      dataAnalysis(response)
    } catch (e) {
      console.log(e)
    }
  }

  const dataAnalysis = response => {
    let finaldata = {}
    if (sortBy === "person") {
      props.selectedFactory.workReportScope.map(key => {
        finaldata[key.name] = 0.0
      })

      response.map(data => {
        data.timeList.map(nesData => {
          if (user === data.submitedBy) {
            finaldata[nesData.scope] =
              Number(finaldata[nesData.scope]) + Number(nesData.duration)
          }
        })
      })
    } else {
      let finalworkdata = {}
      let userListInTeam: any[] = []

      props.selectedFactory &&
        props.selectedFactory.teams &&
        props.selectedFactory.teams
          .filter((team: any) => team.status !== false) // hide inactive staff
          .map((team, tIndex) => {
          const find: any = _.find(userList, ["_id", team.userId])
          if (find) {
            finalworkdata[find._id] = 0.0
            userListInTeam.push(find)
          }
        })

      response.map(data => {
        data.timeList.map(nesData => {
          if (nesData.scope === user) {
            finalworkdata[data.submitedBy] =
              Number(finalworkdata[data.submitedBy]) + Number(nesData.duration)
          }
        })
      })
      userListInTeam.map(user => {
        if (Object.keys(finalworkdata).includes(user._id)) {
          finaldata[user.name + user.role] = finalworkdata[user._id]
        }
      })
    }
    setTimeout(() => {
      setFinalReport(finaldata)
    }, 10)
  }

  useEffect(() => {
    getUsers()
  }, [])

  const filterUserName: any = _.find(userList, ["_id", user])

  // console.log("filterUserName", filterUserName, finalReport)

  return (
    <React.Fragment>
      <Container fluid>
        {/* <h1>Im ready for analysis ----------------></h1> */}
        <Row>
          <Col md={2}>
            <Flatpickr
              className="form-control d-block"
              placeholder="Select Date"
              // style={{ margin: "2px" }}

              value={range}
              onChange={e => {
                // updateListValue(
                //   moment(e[0]).format("HH:mm"),
                //   "startDate",
                //   tIndex
                // )

                if (e.length === 2) {
                  // console.log("range picker", e)
                  // console.log("loggg", [
                  //   moment(e[0]).format("YYYY-MM-DD"),
                  //   moment(e[1]).format("YYYY-MM-DD"),
                  // ])
                  let startdate = moment(e[0]).format("YYYY-MM-DD")
                  let endDate = moment(e[1]).format("YYYY-MM-DD")

                  setRange([startdate, endDate])
                }
              }}
              options={{
                // enableTime: true,
                // noCalendar: true,
                // dateFormat: "H:i",
                mode: "range",
                dateFormat: "Y-m-d",
                // defaultDate: ["2016-10-10", "2016-10-20"],
              }}
            />
          </Col>
          <Col md={2}>
            <MwSelect
              value={sortBy}
              onChange={(val: any) => {
                setSortBy(val)
                setUserId("")
                setFinalReport({})
              }}
              options={[
                { value: "person", label: "Sort by Person" },
                { value: "work", label: "Sort by Work" },
              ]}
            />
          </Col>
          <Col md={4}>
            {sortBy === "person" ? (
              <MwSelect
                value={user}
                placeholder="Select person"
                onChange={(val: any) => {
                  setUserId(val)
                  setFinalReport({})
                }}
                options={(props.selectedFactory && props.selectedFactory.teams
                  ? props.selectedFactory.teams
                  : []
                )
                  .map((team: any) => {
                    const find: any = _.find(userList, ["_id", team.userId])
                    return find
                      ? { value: team.userId, label: `${find.name} (${find.role})` }
                      : null
                  })
                  .filter(Boolean)}
              />
            ) : (
              <MwSelect
                value={user}
                placeholder="Select scope"
                onChange={(val: any) => {
                  setUserId(val)
                  setFinalReport({})
                }}
                options={(props.selectedFactory && props.selectedFactory.workReportScope
                  ? props.selectedFactory.workReportScope
                  : []
                ).map((op: any) => ({ value: op.name, label: op.name }))}
              />
            )}
          </Col>
          <Col>
            <Button
              style={{ marginLeft: "2px", marginRight: "2px" }}
              onClick={filter}
              color="success"
            >
              Search
            </Button>
          </Col>
        </Row>
        {Object.keys(finalReport).length > 0 && (
          <Row style={{ marginTop: "20px" }}>
            <Col md={10}>
              <Card>
                <CardBody>
                  <CardTitle>
                    {sortBy === "work" ? (
                      user
                    ) : (
                      <React.Fragment>
                        {filterUserName && filterUserName.name}(
                        {filterUserName && filterUserName.role})
                      </React.Fragment>
                    )}
                  </CardTitle>
                  {/* Graphic representation of the work-hours breakdown for
                      easy understanding, above the detailed table. */}
                  {(() => {
                    const cats = Object.keys(finalReport)
                    const data = cats.map((k) => Number((finalReport as any)[k]) || 0)
                    const options: any = {
                      chart: { toolbar: { show: false }, fontFamily: "inherit" },
                      plotOptions: { bar: { horizontal: true, borderRadius: 4, distributed: true, barHeight: "60%" } },
                      colors: ["#2EA99B", "#1D3A5F", "#e0a83c", "#e07a6f", "#6c8ebf", "#8a97a8", "#7cb342", "#c0392b"],
                      dataLabels: { enabled: true, formatter: (v: any) => `${v} h`, style: { colors: ["#333"] }, offsetX: 24 },
                      grid: { borderColor: "#eef1f4" },
                      xaxis: { categories: cats, title: { text: "Hours" } },
                      legend: { show: false },
                      tooltip: { y: { formatter: (v: any) => `${v} hours` } },
                    }
                    return (
                      <ReactApexChart
                        options={options}
                        series={[{ name: "Hours", data }]}
                        type="bar"
                        height={Math.max(220, cats.length * 46)}
                      />
                    )
                  })()}

                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <thead className="thead-light">
                        <tr>
                          <th>#</th>
                          {/* <th>Person Name</th> */}
                          <th>Work report</th>
                          <th>Hours</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(finalReport).map((data, i) => {
                          return (
                            <tr key={i}>
                              <th scope="row">{i + 1}</th>
                              <td>{data}</td>
                              <td>{finalReport[data]} Hours</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  // console.log("state", state)

  const { user } = state.user
  const { selected: selectedFactory } = state.factory
  const isAdmin =
    selectedFactory && selectedFactory.permission.includes("ADMIN")
      ? true
      : false

  return {
    selectedFactory,
    user,
    isAdmin: isAdmin,
    dailyWorkReport: state.dailyWorkReport,
  }
}

export default withRouter(connect(mapStateToProps, {})(Analysis))
